<template>
  <div class="public-header-modular">
    <div class="header-top-modualr">
      <div class="header-center-modualr">
        <div class="left-item-modular">
          <div class="open-menu" @click="switchMenu">
            <i class="el-icon-s-operation"></i>
          </div>
          <div class="left-item currency-type-item">
            <div class="currency-list-modualr">
              <el-dropdown
                trigger="click"
                @command="currencyChange"
                @visible-change="changeCurrencyDropdownshow"
              >
                <span class="el-dropdown-link">
                  <span>{{ currCurrency }}</span>
                  <img
                    class="down-arrow-icon2"
                    v-if="currencyDropdownshow"
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                  <img
                    class="down-arrow-icon"
                    v-else
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="index"
                    v-for="(item, index) in rateList"
                    :key="index"
                  >
                    {{ item.currency_name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="left-item">
            <div class="language-category-modular">
              <el-dropdown
                trigger="click"
                @command="languageChange"
                @visible-change="changeLanguageDropdownshow"
              >
                <span class="el-dropdown-link">
                  <span>{{ currLanguage }}</span>
                  <img
                    class="down-arrow-icon2"
                    v-if="currencyDropdownshow"
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                  <img
                    class="down-arrow-icon"
                    v-else
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="index"
                    v-for="(item, index) in languageList"
                    :key="index"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div class="right-item-modualr">
          <div
            class="right-item"
            @click="toshoppingcart()"
            style="cursor: pointer"
          >
            <img
              class="shop-cart-icon"
              v-if="shopCartNum == 0"
              src="../../assets/public/shopping-cart-icon.png"
              alt=""
            />
            <el-badge :value="shopCartNum" class="item" v-else>
              <img
                class="shop-cart-icon"
                src="../../assets/public/shopping-cart-icon.png"
                alt=""
              />
            </el-badge>
            <span class="shop-cart-text">
              <!-- {{ pageText.cartText }} -->
              {{ pageTextArr[1] }}
            </span>
          </div>
          <div class="right-item signed-item" v-if="isLogin == 1">
            <el-dropdown
              trigger="click"
              @command="handleCommand3"
              @visible-change="changeUserCentereDropdownshow"
            >
              <span class="el-dropdown-link">
                <img
                  class="user-portrait-icon"
                  :src="userInfo.head_img"
                  alt=""
                />
                <span class="userName">{{
                  userInfo.surname + userInfo.name
                }}</span>
                <img
                  class="select-icon2"
                  v-if="userCenterDropdownshow"
                  src="../../assets/public/up-arrow-icon.png"
                  alt=""
                />
                <img
                  class="select-icon"
                  v-else
                  src="../../assets/public/up-arrow-icon.png"
                  alt=""
                />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">
                  <div class="personal-operation-item">
                    <img
                      class="personal-operation-icon"
                      src="../../assets/public/uer-crnter-icon.png"
                      alt=""
                    />
                   <span>{{ pageTextArr[3] }}</span> 
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="2">
                  <div class="personal-operation-item">
                    <img
                      class="personal-operation-icon"
                      src="../../assets/public/login-in-icon.png"
                      alt=""
                    />
                    <!-- {{ pageText.logoutText }} -->
                    <span>{{ pageTextArr[2] }}</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="right-item" v-else @click="toLogin()">
            <img
              class="user-portrait-icon"
              src="../../assets/public/portrait-icon.png"
              alt=""
            />
            <span class="user-portrait-text">
              <!-- {{ pageText.loginorrefisterText }} -->
              {{ pageTextArr[4] }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="search-modular">
      <!-- 手机 -->
      <!-- <div class="search-modular-el-row" v-if="equipmentType == 1">
        <el-row :gutter="20" class="">
          <el-col :lg="6" :xl="6" :xs="6">
            <div class="left-logo-modular">
              <img class="logo-img" src="../../assets/public/logo.png" alt="" @click="toHome()" />
            </div>
          </el-col>
          <el-col :lg="18" :xl="18" :xs="18">
            <div class="right-search-modular">
              <div class="search-input-modular">
                <el-input placeholder="" class="search-input" v-model="searchKey" @clear="clearInput()"
                  @keyup.enter.native="searchByInput()">
                  <el-button slot="append" @click="searchByInput()">搜索</el-button>
                </el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg="18" :xl="18" :xs="24">
            <div class="search-tar-modular">
              <el-breadcrumb separator="|">
                <el-breadcrumb-item v-for="(item, index) in searchTar" v-if="index < 5" :key="index">
                  <span class="hot-item-span" @click="searchByhotWords(item.word)">{{ item.word }}</span>
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </el-col>
        </el-row>
      </div> -->
      <div class="search-modular-el-row">
        <!-- pc -->
        <el-row :gutter="20" class="">
          <el-col :lg="6" :xl="6" :xs="6">
            <div class="left-logo-modular">
              <!-- ../../assets/public/logo.png -->
              <div class="logo-img show-img" v-if="!logo"></div>
              <img class="logo-img" v-else :src="logo" alt="" @click="toHome()" />
            </div>
          </el-col>
          <el-col :lg="18" :xl="18" :xs="18">
            <div class="right-search-modular">
              <div class="search-input-modular">
                <el-input
                  placeholder=""
                  class="search-input"
                  clearable
                  v-model="searchKey"
                  @clear="clearInput()"
                  @keyup.enter.native="searchByInput()"
                >
                  <el-button slot="append" @click="searchByInput()">
                    <!-- {{ pageText.searchText }} -->
                    {{ pageTextArr[0] }}
                  </el-button>
                </el-input>
              </div>
              <!-- <div class="search-tar-modular">
                <el-breadcrumb separator="|" style="display: flex;justify-content: flex-start;white-space: nowrap;">
                  <el-breadcrumb-item v-for="(item, index) in searchTar" v-if="index < searchTarLength" :key="index">
                    <span class="hot-item-span" @click="searchByhotWords(item.word)">{{ item.word }}</span>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div> -->
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="">
          <el-col :lg="6" :xl="6" :xs="0">
            <div
              style="width: 100%; height: 20px; background-color: #ffffff"
            ></div>
          </el-col>
          <el-col :lg="18" :xl="18" :xs="24" style="padding-left: 20px;padding-right: 20px;">
            <div class="search-tar-modular">
              <el-breadcrumb
                separator="|"
                style="
                  display: flex;
                  justify-content: flex-start;
                  white-space: nowrap;
                  width: 100%;
                "
              >
                <el-breadcrumb-item
                  v-for="(item, index) in searchTar"
                  v-if="index < searchTarLength"
                  :key="index"
                >
                  <span
                    class="hot-item-span"
                    @click="
                      searchByhotWords(
                        currLanguageId == 3 ? item.eng_word : item.word
                      )
                    "
                    >{{ currLanguageId == 3 ? item.eng_word : item.word }}</span
                  >
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 侧边栏菜单 -->
    <el-drawer
      size="50%"
      :visible.sync="drawer"
      :modal="false"
      direction="ltr"
      :with-header="false"
    >
      <el-menu
        default-active="0-0"
        :unique-opened="false"
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
      >
        <!-- <el-menu-item v-for="(item, index) in menuTarList" :key="index" :index="item.path">
          <span slot="title">{{ item.level1.name }}</span>
        </el-menu-item> -->

        <div v-for="(menu, i) in menuTarList" :key="i">
          <el-submenu v-if="menu.child.length > 0">
            <template slot="title">
              <span @click="menuClick(menu.id)">{{
                currLanguageId == 3 ? menu.eng_name : menu.name
              }}</span>
            </template>
            <div v-for="(item, index) in menu.child" :key="index">
              <el-menu-item
                :index="i + '-' + index"
                v-if="item.children == null"
              >
                <span slot="title" @click.stop="menuProductClick(item.id)">{{
                  currLanguageId == 3 ? item.eng_name : item.name
                }}</span>
              </el-menu-item>
              <el-submenu :index="i + '-' + index" v-else>
                <template slot="title">
                  <span>{{
                    currLanguageId == 3 ? item.eng_name : item.name
                  }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    v-for="(item2, index2) in item.children"
                    :key="index2"
                    :index="item.id + '-' + index + '-' + index2"
                    @click="searchProductByType(index, item.id, item2.id)"
                    >{{
                      currLanguageId == 3 ? item2.eng_name : item2.name
                    }}</el-menu-item
                  >
                </el-menu-item-group>
              </el-submenu>
            </div>
          </el-submenu>
          <el-menu-item :index="i" v-else>
            <span slot="title" @click="menuClick(menu.id)">{{
              currLanguageId == 3 ? menu.eng_name : menu.name
            }}</span>
          </el-menu-item>
        </div>
      </el-menu>
    </el-drawer>
    <!-- <MapContainer ref='mapNav'></MapContainer> -->
  </div>
</template>
<script>
// import MapContainer from "../public/MapContainer.vue";

export default {
  // components: {
  //   MapContainer
  // },
  inject: ["reload"],
  name: "header",
  data() {
    return {
      logo: "",
      currLanguageId: 0, //
      currCurrency: "USD", //货币种类
      currLanguage: "简体中文", //语言种类
      currencyDropdownshow: false, //货币下拉选择
      languageDropdownshow: false, //语言下拉选择
      userCenterDropdownshow: false, //语言下拉选择
      equipmentType: 0, //1-手机端,0-pc
      shopCartNum: 0, //localStorage.getItem("cartCount"), //购物车数量
      activeIndex2: "1",
      searchKey: "",
      searchTar: [], //热搜词条
      searchTarLength: 8,
      pageWidth: 1080, //页面宽度
      menuTarList: [], //一级导航栏
      menuTar: [], //产品二级导航栏
      isLogin: 0,
      userInfo: {}, //用户登录着信息
      // 货币 -汇率
      rateList: [],
      // 预览列表
      languageList: [],
      drawer: false,
      pageText: {
        searchText: "搜索",
        cartText: "购物车",
        logoutText: "退出登录",
        personcenterText: "个人中心",
        loginorrefisterText: "登录/注册",
      },
      pageTextArr: [
        "搜索",
        "购物车",
        "退出登录",
        "个人中心",
        "登录/注册",
        "您还没有登录，请先登录",
        "确定",
      ],
    };
  },
  methods: {
    /**
     * 产品id点击 - 全部
     * @param {*} id
     */
    menuProductClick(id) {
      this.$router.push(
        {
          path: "/productShow",
          query: { type_id: id },
        },
        () => {}
      );
      localStorage.setItem("menuActiveIndex", 1);
      this.$parent.$parent.reload();
    },

    /**
     * 菜单选择
     * @param {*} id
     */
    menuClick(id) {
      switch (id) {
        case "4":
          this.$router.push(
            {
              path: "/",
            },
            () => {}
          );
          break;
        case "7":
          this.$router.push(
            {
              path: "/productShowByType",
              query: { type_id: "1" },
            },
            () => {}
          );
          localStorage.setItem("menuActiveIndex", 2);
          this.$parent.$parent.reload();
          break;
        case "8":
          this.$router.push(
            {
              path: "/productShowByType",
              query: { type_id: "2" },
            },
            () => {}
          );
          localStorage.setItem("menuActiveIndex", 3);
          this.$parent.$parent.reload();
          break;
        case "9":
          this.$router.push(
            {
              path: "/productShowByType",
              query: { type_id: "5" },
            },
            () => {}
          );
          localStorage.setItem("menuActiveIndex", 4);
          this.$parent.$parent.reload();
          break;
        case "10":
          this.$router.push(
            {
              path: "/aboutUs",
            },
            () => {}
          );
          break;
        case "11":
          this.$router.push(
            {
              path: "/blogManagement",
            },
            () => {}
          );
          break;
        case "12":
          this.$router.push(
            {
              path: "/forumManagement",
            },
            () => {}
          );
          break;

        default:
          break;
      }
      if(id != 5){
        this.drawer = false;
      }
    },

    handleSelect() {},
    /**
     * 根据类型获取商品
     * @param {*} index
     * @param {*} id
     */
    searchProductByType(index, levId, id) {
      let that = this;
      that.drawer = false;
      // 产品类型ID
      this.$router.push(
        {
          path: "/productShow",
          query: {
            currProductTypeId: id,
            index: index,
            levId: levId,
            pageStaus: 1,
          },
        },
        () => {}
      );
      this.$parent.$parent.reload();
    },

    /**
     * 更改购物车的数量
     */
    updateCartNum() {
      if (localStorage.getItem("isLogin") != 1) {
        that.shopCartNum = localStorage.getItem("cartCount");
      }
    },
    /**
     * 跳转商品
     */
    toHome() {
      this.$router.push(
        {
          path: "/",
        },
        () => {}
      );
      this.$parent.$parent.reload();
      // this.$parent.setHeaderActive();
    },

    /**
     * 跳转对应页面
     * @param {*} path
     */
    toPath(path) {
      this.$router.push({
        path: path,
      });
      this.drawer = false;
    },

    /**
     * 购物车
     */
    toshoppingcart() {
      this.$router.push({
          path: "/shoppingcart",
        });
      // if (localStorage.getItem("isLogin") == 1) {
      //   this.$router.push({
      //     path: "/shoppingcart",
      //   });
      // } else {
      //   this.$alert(this.pageTextArr[5], "", {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: this.pageTextArr[6],
      //   })
      //     .then(() => {
      //       this.$router.push({
      //         path: "/login",
      //       });
      //     })
      //     .catch((action) => {
      //     });
      // }
    },

    /**
     * 个人中心
     */
    toPersonalCenter() {
      this.$router.push({
        path: "/personalCenter",
      });
    },

    /**
     * 显示个人操作
     */
    showOperation() {
      this.userCenterDropdownshow = !this.userCenterDropdownshow;
    },

    /**
     * 退出-登录页面
     */
    toLogin() {
      // window.localStorage.clear();
      window.localStorage.removeItem("userInfo");
      window.localStorage.removeItem("url");
      window.localStorage.removeItem("token");
      localStorage.setItem("isLogin", 0);
      this.$router.push({
        path: "/login",
      });
    },

    /**
     * 判断是手机还是PC 更改展示的数据长短
     */
    judgePcOrPhone() {
      let that = this;
      that.equipmentType = localStorage.getItem("equipmentType");

      if (that._isMobile()) {
        // 1-手机端
        that.searchTarLength = 5;
        // that.getMenuList();
        that.getCategoryList();
      } else {
        // 0-pc端
        // that.searchTarLength = 9;
        if (that.pageWidth >= 1600) {
          that.searchTarLength = 8;
        } else if (1200 <= that.pageWidth < 1600) {
          that.searchTarLength = 6;
        } else if (500 < that.pageWidth < 1200) {
          that.searchTarLength = 7;
        } else {
          that.searchTarLength = 4;
        }
      }
    },

    /**
     * 货币下拉选择
     * @param {*} command
     */
    currencyChange(command) {
      // command - 下标index
      let that = this;
      that.currCurrency = that.rateList[command].currency_name;
      // 更改汇率-刷新
      if (that.rateList[command].id != localStorage.getItem("exchangeRateId")) {
        this.$parent.$parent.reload();
      }
      localStorage.setItem("exchangeRateId", that.rateList[command].id);
      localStorage.setItem(
        "currencyName",
        that.rateList[command].currency_name
      );
      localStorage.setItem(
        "currencySymbol",
        that.rateList[command].currency_symbol
      );
      localStorage.setItem(
        "currencyRate",
        that.rateList[command].exchange_rate
      );
    },

    /**
     * 货币-显示隐藏
     * @param {*} value
     */
    changeCurrencyDropdownshow(value) {
      this.currencyDropdownshow = value;
    },

    /**
     * 语言下拉框点击
     * @param {*} command
     */
    languageChange(command) {
      // command - 下标index
      let that = this;
      that.currLanguage = that.languageList[command].name;
      let oldLanguage = localStorage.getItem("oldLanguageCode");
      if (oldLanguage == "" || oldLanguage == null) {
        localStorage.setItem(
          "oldLanguageCode",
          that.languageList[command].code
        );
      } else {
        localStorage.setItem("oldLanguageCode", oldLanguage);
      }
      localStorage.setItem("curLanguageCode", that.languageList[command].code);
      localStorage.setItem("curLanguage", that.languageList[command].name);
      localStorage.setItem("curLanguageType", that.languageList[command].id);
      localStorage.setItem("curLanguageIndex", command);
      this.$parent.$parent.reload();
      // vue 国际化 传入语言id
      // this.$parent.$parent.lang_change(that.languageList[command].id);
    },

    /**
     *  语言-显示隐藏
     * @param {*} value
     */
    changeLanguageDropdownshow(value) {
      this.languageDropdownshow = value;
    },

    /**
     * user-center
     * @param {*} command
     */
    handleCommand3(command) {
      let that = this;
      if (command == 1) {
        // 个人中心
        that.toPersonalCenter();
      } else {
        // 退出登录
        that.toLogin();
      }
    },

    /**
     *  user-center-显示隐藏
     * @param {*} value
     */
    changeUserCentereDropdownshow(value) {
      this.userCenterDropdownshow = value;
    },

    /**
     * 汇率列表
     */
    getRateList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      // 判断是否已经有语言存在
      // if (
      //   localStorage.getItem("currencyName") != null ||
      //   localStorage.getItem("currencySymbol") != null ||
      //   localStorage.getItem("currencyRate") != null
      // ) {
      //   that.rateList = JSON.parse(localStorage.getItem("rateList"));
      //   that.currCurrency = localStorage.getItem("currencyName");
      //   return;
      // }
      this.$http.getRateList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.rateList = res.data;
            if (!localStorage.getItem("exchangeRateId")) {
              localStorage.setItem("exchangeRateId", that.rateList[0].id);
              localStorage.setItem(
                "currencyName",
                that.rateList[0].currency_name
              );
              localStorage.setItem(
                "currencySymbol",
                that.rateList[0].currency_symbol
              );
              localStorage.setItem(
                "currencyRate",
                that.rateList[0].exchange_rate
              );
              that.currCurrency = that.rateList[0].currency_name;
            } else {
              that.currCurrency = localStorage.getItem("currencyName");
            }
            localStorage.setItem("rateList", JSON.stringify(res.data));
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 语言列表
     */
    getLanguageList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      // 判断是否已经有语言存在
      // if (
      //   localStorage.getItem("curLanguage") != null ||
      //   localStorage.getItem("curLanguageType") != null || localStorage.getItem("languageList")!=null
      // ) {
      //   that.languageList = JSON.parse(localStorage.getItem("languageList"));
      //   that.currLanguage = localStorage.getItem("curLanguage");
      //   return;
      // }
      this.$http.getLanguageList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.languageList = res.data;
            if (!localStorage.getItem("curLanguage") ||  JSON.stringify(res.data)!=localStorage.getItem("languageList")) {
              localStorage.setItem("curLanguage", that.languageList[0].name);
              localStorage.setItem("curLanguageType", that.languageList[0].id);
              localStorage.setItem(
                "oldLanguageCode",
                that.languageList[0].code
              );
              localStorage.setItem(
                "curLanguageCode",
                that.languageList[0].code
              );
              
              that.currLanguage = that.languageList[0].name;
              for(let i=0;i<res.data.length;i++){
                localStorage.setItem("curLanguageIndex", 0);
                if(res.data[i].is_default==1){
                that.languageChange(i);
                }
              }
            } else {
              that.currLanguage = localStorage.getItem("curLanguage");
            }
            localStorage.setItem("languageList", JSON.stringify(res.data));
            
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 用户信息
     */
    getUserInfo() {
      let that = this;
      // token 不调用
      if (localStorage.getItem("token") == null) {
        return;
      }
      if (localStorage.getItem("userInfo") != null) {
        that.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        return;
      }
      this.$http.getUserInfo(
        null,
        (res) => {
          if (res.ret == 1) {
            that.userInfo = res.data;
            localStorage.setItem("userInfo", JSON.stringify(res.data));
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     *
     */
    switchMenu() {
      if (!this.drawer) {
        this.drawer = true;
      } else {
        this.drawer = false;
      }
    },

    /**
     * 热搜词条
     */
    getHotWordList() {
      let that = this;
      this.$http.getHotWordList(
        null,
        (res) => {
          if (res.ret == 1) {
            that.searchTar = res.data;
            // api数据翻译
            that.translateApiData(res.data, "word");
            console.log("getHotWordList", res.data);
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    /**
     * 获取一级导航栏
     */
    getMenuList() {
      let that = this;
      // this.getCategoryList();
      this.$http.getMenuList(
        null,
        (res) => {
          if (res.ret == 1) {
            // 清空
            that.menuTarList = res.data;
            console.log("that.menuTarList", that.menuTarList);
            // res.data.forEach((v, i) => {
            //   that.menuTarList.push({
            //     title: v.name,
            //     index: i.toString(),
            //     eng_title: v.eng_name
            //   })
            // });
            that.menuTarList.forEach((item) => {
              if (item.id == 5) {
                item.child = that.menuTar;
              }
            });
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取产品二级导航栏
     */
    getCategoryList() {
      let that = this;
      // if (localStorage.getItem("menuTar") != null) {
      //   that.menuTar = JSON.parse(localStorage.getItem("menuTar"));
      //   return;
      // }
      this.$http.getCategoryList(
        null,
        (res) => {
          if (res.ret == 1) {
            // 清空
            that.menuTar = res.data;

            // 存储
            localStorage.setItem("menuTar", JSON.stringify(that.menuTar));
            that.getMenuList();
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    /**
     * 获取博客二级导航栏
     */
    //  getBlogType() {
    //   let that = this;
    //   let data = {
    //     page: 1,
    //     pagesize: 100,
    //   }

    //   this.$http.getBlogType(
    //     data,
    //     (res) => {
    //       if (res.ret == 1) {
    //         that.blogTypeData = res.data.reverse();
    //         that.activeBlogTypeId = that.blogTypeData[0].id;
    //       } else {
    //         // this.$message.error(res.msg);
    //       }
    //     },
    //    (res) => {
    //       // this.$message.error(res.msg);
    //     }
    //   );
    // },
    /**
     * 获取论坛二级导航栏
     */
    //  getUserBlogType() {
    //   let that = this;
    //   let data = {
    //     page: 1,
    //     pagesize: 100,
    //   }

    //   this.$http.getUserBlogType(
    //     data,
    //     (res) => {
    //       if (res.ret == 1) {
    //         that.headerBar = res.data.reverse();
    //         that.headerBarTypeID = that.headerBar[0].id;
    //         that.headerBarTypeIDTitle = that.headerBar[0].type_name;
    //         // 回复的主题分类
    //         res.data.forEach(v => {
    //           that.options.push(
    //             {
    //               value: v.id,
    //               label: v.type_name
    //             }
    //           )
    //         });
    //       } else {
    //         this.$message.error(res.msg);
    //       }
    //     },
    //     (res) => {
    //       // this.$message.error(res.msg);
    //     }
    //   );
    // },

    /**
     * 跟换热词搜索
     * @param {*} word
     */
    searchByhotWords(word) {
      let that = this;
      that.searchKey = word;
      that.searchByInput();
    },

    /**
     * 清空
     */
    clearInput() {
      let that = this;
      that.searchKey = "";

      // /searchProduct
      if (this.$route.path == "/productShow") {
        that.searchByInput();
      }
    },
    /**
     * 搜索
     */
    searchByInput() {
      let that = this;
      // 默认调转到首页的下摆哦

      // this.$parent.setHeaderActive();
      // console.log('index----',this.$parent.$refs.headerMenuModular.activeIndex);
      // that.$parent.$refs.headerMenuModular.activeIndex = 1;
      this.$parent.$parent.reload();

      // 路由地址跳转-添加参数
      this.$router.push(
        {
          path: "/searchProduct",//searchProduct
          query: { searchKey: that.searchKey },
        },
        () => {}
      );
    },

    /**
     * 语言翻译-单个词语
     */
    pageTranslate(text) {
      let that = this;
      let transformText = "";
      for (const key in that.pageText) {
        transformText += key + "=" + that.pageText[key] + "&";
      }

      // console.log("transformText",);
      // that.languageTranslate(transformText);
    },

    /**
     * 语言翻译 - 单个词语
     * @param {*} text
     */
    languageTranslate(text) {
      let that = this;
      this.$parent.translate(
        text,
        (res) => {
          // 处理页面 死数据 -翻译
          that.processingResults(res.data);
        },
        (res) => {}
      );
    },

    /**
     * 处理返回的结果
     */
    processingResults(data) {
      let that = this;
      let textArr = data.split("&amp;");

      textArr.forEach((v, i) => {
        if (v != "") {
          for (const key in that.pageText) {
            if (v.split("=")[0] == key) {
              that.pageText[key] = v.split("=")[1];
            }
          }
        }
      });
    },

    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, title) {
      let that = this;
      let newTextArr = [];

      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      // 翻译
      that.languageTranslateByArr(newTextArr, title);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, title) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, title);
        },
        (res) => {}
      );
    },

    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, title) {
      let that = this;
      data.forEach((v, i) => {
        that.searchTar[i][title] = v.translation;
      });
    },

    /**
     * 获取网站logo以及名称
     */
    getSystemConfig() {
      this.$http.getSystemConfig({}, (res) => {
        if (res.ret == 1) {
          this.logo = res.data.sys_site_logo;
        }
      });
    },
    /**
     *
     * 获取本机ip地址
     */
    getUserIP(onNewIP) {
      //获取不到可能是因为chrome浏览器版本过高，需要修改浏览器配置如下

      //在chrome地址栏输入：chrome://flags/#enable-webrtc-hide-local-ips-with-mdns

      // 把 Anonymize local IPs exposed by WebRTC 设置为 disabled

      //不能确保每一个浏览器都设置打开webRTC~~~~~

      console.log("getUserIP-----");
      let MyPeerConnection =
        window.RTCPeerConnection ||
        window.mozRTCPeerConnection ||
        window.webkitRTCPeerConnection;

      let pc = new MyPeerConnection({
        iceServers: [],
      });

      let noop = () => {};

      let localIPs = {};

      let ipRegex =
        /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

      let iterateIP = (ip) => {
        if (!localIPs[ip]) {
          onNewIP(ip);
        }

        localIPs[ip] = true;
      };

      pc.createDataChannel("");

      pc.createOffer()
        .then((sdp) => {
          sdp.sdp.split("\n").forEach(function (line) {
            if (line.indexOf("candidate") < 0) {
              return;
            }

            line.match(ipRegex).forEach(iterateIP);
          });

          pc.setLocalDescription(sdp, noop, noop);
        })
        .catch((reason) => {
          console.log(reason);
        });

      pc.onicecandidate = (ice) => {
        if (
          !ice ||
          !ice.candidate ||
          !ice.candidate.candidate ||
          !ice.candidate.candidate.match(ipRegex)
        ) {
          return;
        }

        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArr = newpagetextArr;
      });
    },
    getLongitudeLatitude() {
      let that = this;
      if (!localStorage.getItem("internalCountry")) {
        //如果该对象存在，那么地理位置服务可用。
        if ("geolocation" in navigator) {
          /* 地理位置服务可用 */
          var options = {
            enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
            timeout: 3000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
            maximumAge: 0, //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
          };
          function success(position) {
            //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
            //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
            var lat = position.coords.latitude; //当前位置的纬度
            var lng = position.coords.longitude; //当前位置精度
            console.log(lat, lng);
            let data = {
              longitude: lng,
              dimension: lat,
            };
            that.getAddress(data);
          }
          function error(err) {
            var errorType = [
              "您拒绝共享位置信息",
              "获取不到位置信息",
              "获取位置信息超时",
            ];
            console.log(errorType[err.code - 1]);
            let data = {
              longitude: "",
              dimension: "",
            };
            that.getAddress(data);
          }

          navigator.geolocation.getCurrentPosition(success, error, options);
        } else {
          /* 地理位置服务不可用 */
          console.log("无法获取您的位置，请检查定位是否开启或刷新重试");
        }
      }
    },
    getAddress(data) {
      let that = this;

      if (!localStorage.getItem("internalCountry")) {
        that.$http.getAddress(data, (res) => {
          if (res.ret == 1) {
            localStorage.setItem("internalCountry", res.internalCountry); //
            if (res.internalCountry == 2) {
              that.languageChange(1);
            }
          }
        });
      }
    },
    /**
     * 判断手机型号
     */
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  mounted() {
    let that = this;
    // that.getLongitudeLatitude();

    // 当前语言
    that.currLanguageId = localStorage.getItem("curLanguageType");
    //
    that.isLogin = localStorage.getItem("isLogin");
    // 当前汇率
    that.currCurrency = localStorage.getItem("currencyName");
    // 页面宽度
    that.pageWidth = document.documentElement.clientWidth;
    that.getSystemConfig();
    that.getRateList(); //汇率
    that.getLanguageList(); //语言
    // 用户信息
    that.getUserInfo();
    // 热搜词条
    that.getHotWordList();
    // 导航栏
    // that.getCategoryList();
    // 菜单
    that.judgePcOrPhone();
    // 翻译
    that.pageTranslate();

    // that.getMenuList();
    // that.getUserIP((ip)=>{
    //   console.log("ip-------",ip);
    // })
    that.languageTranslateByArrs(that.pageTextArr);
    //
    // that.$refs.mapNav.getCurrentLocation(res=>{
    //   console.log('res',res);

    // })
  },
  props: ["number"],
};
</script>

<style lang="scss">
.public-header-modular {
  width: 100%;

  .header-top-modualr {
    width: 100%;
    padding: 13px 0px;
    background: #f6f6f6;

    .header-center-modualr {
      width: 1200px;
      margin: auto;
      height: 100%;
      display: flex;
      justify-content: space-between;

      .left-item-modular {
        display: flex;
        align-items: center;

        .open-menu {
          display: none;
        }

        .left-item {
          cursor: pointer;
        }

        .left-item span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }

        .down-arrow-icon {
          width: 11px;
          height: 5px;
          margin-left: 6px;
          vertical-align: middle;
        }

        .down-arrow-icon2 {
          transform: rotate(180deg);
          width: 11px;
          height: 5px;
          margin-left: 6px;
          vertical-align: middle;
        }

        .left-item:last-child {
          margin-left: 32px;
        }
      }

      .right-item-modualr {
        display: flex;
        align-items: center;

        .right-item span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin-right: 10px;
        }

        .right-item {
          cursor: pointer;

          .shop-cart-icon,
          .user-portrait-icon {
            width: 20px;
            height: 20px;
            vertical-align: middle;
          }

          .user-portrait-icon {
            width: 26px;
            height: 26px;
            margin-right: 5px;
            border-radius: 50%;
            position: relative;
            top: -1px;
          }

          .userName {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            margin-right: 2px;
          }

          .select-icon {
            transform: rotate(180deg);
            width: 10px;
            height: 5px;
            vertical-align: middle;
          }

          .select-icon2 {
            width: 10px;
            height: 5px;
            vertical-align: middle;
          }
        }

        .right-item:last-child {
          margin-left: 28px;
        }

        // 操作
        .signed-item {
          position: relative;
          z-index: 10;
        }
      }
    }
  }

  .search-modular {
    width: 100%;
    margin: auto;
    padding-top: 18px;
    padding-bottom: 18px;
    background-color: #ffffff;

    .search-modular-el-row {
      width: 50%;
      margin: auto;
    }

    .left-logo-modular {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-left: -10px;
      .logo-img {
        width: 90%;
        cursor: pointer;
      }
      .show-img {
        min-width: 130px;
        height: 44px;
      }
    }

    .right-search-modular {
      width: 90%;
      float: right;

      .search-input-modular {
        .search-input {
          right: 10px;
          width: 100%;
          height: 40px;
          background: #ffffff;
          border: 2px solid #000000;
          border-radius: 20px;

          .el-input__inner {
            background-color: transparent;
            border: 0px;
          }

          .el-input-group__append {
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            border-top-left-radius: 0;
            border-top-right-radius: 20px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 20px;
            background: #000000;
            border: 0;
            right: -2px;
            padding: 0 24px;
          }
        }
      }
    }
  }

  .search-tar-modular {
    display: flex;
    justify-content: space-around;
    margin-top: 12px;
    // overflow-x: scroll;

    .hot-item-span {
      cursor: pointer;
    }
    .hot-item-span:hover {
      color: #ec0000;
    }
  }
}

.el-dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

.personal-operation-item {
  font-size: 16px;
  color: #333;
  // width: 120px;
  text-align: center;
  padding: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;

  .personal-operation-icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    position: relative;
    top: -1px;
    margin-right: 5px;
  }
  
}

@media screen and (max-width: 500px) {
  .public-header-modular {
    .header-top-modualr {
      // position: fixed;
      .header-center-modualr {
        width: 100% !important;

        .left-item-modular {
          justify-content: center;
          width: 50%;
          padding-right: 10px;

          .open-menu {
            display: block;

            i {
              font-size: 20px;
            }
          }

          .left-item {
            margin-left: 15px !important;

            .shop-cart-text,
            .user-portrait-text {
              display: none;
            }
          }
        }

        .right-item-modualr {
          justify-content: space-between;
          width: 18%;
          padding-right: 25px;

          .right-item {
            white-space: nowrap;
            overflow: hide;

            .shop-cart-text,
            .user-portrait-text {
              display: none;
            }

            .userName,
            .select-icon2,
            .select-icon {
              display: none;
            }

            .el-dropdown {
              .user-portrait-icon {
                margin-right: 0;
              }

              .el-dropdown-link {
                margin-right: 0;
              }
            }
          }

          .right-item:last-child {
            margin-left: 0 !important;
          }

          // 操作
          .signed-item {
            position: relative;
            z-index: 10;

            // user-个人中心
            // .personal-operation-modualr {
            //   position: absolute;
            //   top: 30px;
            //   right: 0px;
            //   background-color: #FFFFFF;
            //   border-radius: 10px;
            //   box-shadow: 2px 2px 2px #EEE;
            //   border: 1px solid #EEE;
            //   padding: 5px 0px;

            //   .personal-operation-item {
            //     font-size: 16px;
            //     color: #333;
            //     width: 120px;
            //     text-align: center;
            //     padding: 5px;
            //     cursor: pointer;

            //     .personal-operation-icon {
            //       width: 18px;
            //       vertical-align: middle;
            //       position: relative;
            //       top: -1px;
            //       margin-right: 5px;
            //     }
            //   }
            // }
          }
        }
      }
    }
  }

  .search-modular {
    width: 100% !important;
    // padding-top: 70px !important;

    .search-modular-el-row {
      width: 100% !important;

      .left-logo-modular {
        .logo-img {
          position: relative;
          top: 10px;
          left: 10px;
        }
      }
    }

    .right-search-modular {
      float: none !important;
      margin: auto;

      .search-input-modular {
        .search-input {
          right: 0px !important;
          height: 30px !important;
        }

        .search-input input {
          height: 30px;
          line-height: 30px;
        }
      }
    }

    .search-tar-modular {
      overflow-x: scroll;
      width: 100%;
      .el-breadcrumb__item {
        margin-top: 5px;
      }
    }
  }

  .el-drawer__container .el-menu {
    height: 100%;
    .el-submenu__title {
      span {
        margin-right: 5px;
        width: 90%;
        display: inline-block;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
    .el-menu-item-group {
      .el-menu-item {
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/header.vue